import React from 'react';
import { Space, Tabs, Typography } from 'antd';
import IndividualAccOpening from './IndividualAccOpening';
import CorporateAccOpening from './CorporateAccOpening';

const { Title } = Typography;

export default function AccountOpening() {
  const tabItems = [
    {
      key: '1',
      label: `Individual`,
      children: <IndividualAccOpening />,
    },
    {
      key: '2',
      label: `Corporate`,
      children: <CorporateAccOpening />,
    },
  ];
  return (
    <Space direction="vertical" size={'large'} style={{ width: '100%' }}>
      {/* {tabItems.keys === '1' ? (
        <Title level={4} style={{ margin: 0 }}>
          Individual Account Opening
        </Title>
      ) : (
        <Title level={4} style={{ margin: 0 }}>
          Corporate Account Opening
        </Title>
      )} */}
      <Tabs defaultActiveKey="1" items={tabItems} />
    </Space>
  );
}
